import paracleteLogo from '../assets/logo-pdf.png';

// Shown at /buyer-map while the public buyer map is shut down (see
// isBuyerMapEnabled in utils/accessControl). Deliberately says nothing
// about which link, which deals, or why — anyone holding a share link
// can reach this page, including whoever the link leaked to.
export default function BuyerMapShutDown() {
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: '2rem',
        background: '#0f172a',
        color: '#e2e8f0',
        fontFamily: 'Arial, Helvetica, sans-serif',
      }}
    >
      <div style={{ maxWidth: 460, textAlign: 'center', display: 'grid', gap: '1rem', justifyItems: 'center' }}>
        <img src={paracleteLogo} alt="Paraclete Oil" style={{ width: 128, maxWidth: '60%' }} />
        <h1 style={{ fontSize: '1.25rem', fontWeight: 600, margin: 0 }}>
          This buyer map is no longer available
        </h1>
        <p style={{ margin: 0, lineHeight: 1.6, color: '#94a3b8', fontSize: '0.95rem' }}>
          Buyer map links have been turned off. If you were sent one and still
          need access to these deals, please contact your Paraclete Oil
          representative directly.
        </p>
      </div>
    </main>
  );
}
